import { SECTORS } from "data/locations";
import {
  BattleRatingsData,
  CharacterBaseStats,
  CharacterData,
  ExpandedMedallionsData,
  OnlinePlayerAvatarModel,
  Planets,
  ShipTypes,
  SkillModel,
} from "types";
import { getSkillsMedallionsSpent } from "./skill";
import {
  getAreaData,
  getPropertyData,
  getStatsMedallionsSpent,
  getTotalMedallions,
  getTotalPossibleMedallions,
} from "./stats";

export const MOVEMENT_SPEED_BASELINE = 12; // Movement units per second

// MEDALLIONS

export const getMedallionCounts = (
  battleRatings: BattleRatingsData,
  ship: ShipTypes,
  enhancedBaseStats: CharacterBaseStats,
  pilotSkills: SkillModel[]
): ExpandedMedallionsData => {
  const propertyInfo = getPropertyData("medallions");

  const totalMedallions = getTotalMedallions(battleRatings);
  const statsMedallionsSpent = getStatsMedallionsSpent(enhancedBaseStats, ship);
  const skillsMedallionsSpent = getSkillsMedallionsSpent(pilotSkills);
  const possibleMedallions = getTotalPossibleMedallions();

  const availableMedallions = Math.max(
    0,
    totalMedallions - statsMedallionsSpent - skillsMedallionsSpent
  );

  return {
    possible: propertyInfo.rounder(possibleMedallions),
    total: totalMedallions,
    available: propertyInfo.rounder(availableMedallions),
    statsSpent: statsMedallionsSpent,
    skillsSpent: skillsMedallionsSpent,
  };
};

// LOCATION

export const getSectorsByPlanet = (planet: Planets) => {
  return Object.values(SECTORS)
    .filter((area) => area.planet === planet)
    .filter((area) => !area.isLocked)
    .map((area) => area.slug);
};

export const getAdjacentSectors = (sector: string) => {
  const sectorData = getAreaData(sector);
  return {
    left: sectorData.areaLeft,
    right: sectorData.areaRight,
  };
};

// ONLINE PLAYER

export const formatOnlinePlayerModel = (
  userId: string,
  userName: string,
  characterData: CharacterData
): OnlinePlayerAvatarModel => {
  const { ship, pilot, installedUpgrades, location, battleRatings } =
    characterData;
  const totalMedallions = getTotalMedallions(battleRatings);

  return {
    userId,
    userName,
    ship,
    pilot,
    installedUpgrades,
    totalMedallions,
    area: location.area,
    position: location.position,
  };
};
